import React from "react";
import { IListItemProps } from "components/GridList/ListItem/ListItem.interface";
import {
  ListItemContainer,
  ListItemImage,
} from "components/GridList/ListItem/ListItem.styled";

const ListItem = (props: IListItemProps) => {
  const itemContent = (
    <div className="col-11">
      <h3 className="list-item-title">{props.title}</h3>
      {props.subtitle && (
        <p className="list-item-subtitle mt-3">{props.subtitle}</p>
      )}
    </div>
  );

  const icon = props.icon ? (
    <span title="item-icon" className={`list-icon cl ${props.icon}`}></span>
  ) : null;

  return (
    <ListItemContainer
      tabIndex={0}
      onClick={props.onClick}
      key={`consultor-${props.title}`}
      className="list-item py-2"
    >
      {props.image ? (
        <div className="col-lg-2 col-md-3 col-sm-12">
          <ListItemImage
            src={props.image}
            alt={props.title}
            className="list-item-image"
          />
        </div>
      ) : (
        icon
      )}
      <div
        className={
          props.image
            ? "col-lg-10 col-md-9 col-sm-12"
            : "col-lg-11 col-md-10 col-sm-12"
        }
      >
        {props.children ? props.children : itemContent}
      </div>
    </ListItemContainer>
  );
};

export default ListItem;
